/**
 * @generated SignedSource<<c326af980d8e8d4c7103ccdd835f465c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NewPatronEventsListQuery$variables = {
  count: number;
  cursor?: string | null | undefined;
  endDate?: string | null | undefined;
  eventTags?: ReadonlyArray<string | null | undefined> | null | undefined;
  id: string;
  memberId?: string | null | undefined;
  search?: string | null | undefined;
  startDate?: string | null | undefined;
};
export type NewPatronEventsListQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"FeaturedEventsDepartmentFragment" | "FeaturedEventsFragment" | "UpcomingEventsClub_club" | "UpcomingEventsDepartment_department">;
  } | null | undefined;
};
export type NewPatronEventsListQuery = {
  response: NewPatronEventsListQuery$data;
  variables: NewPatronEventsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventTags"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "cursor"
},
v12 = {
  "kind": "Variable",
  "name": "dateGte",
  "variableName": "startDate"
},
v13 = {
  "kind": "Variable",
  "name": "dateLte",
  "variableName": "endDate"
},
v14 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
},
v15 = {
  "kind": "Variable",
  "name": "tagIds",
  "variableName": "eventTags"
},
v16 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Literal",
    "name": "isFeatured",
    "value": true
  },
  (v15/*: any*/)
],
v17 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v18 = {
  "alias": null,
  "args": (v17/*: any*/),
  "kind": "ScalarField",
  "name": "accessStatusForClient",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": (v17/*: any*/),
  "kind": "ScalarField",
  "name": "signUpStatusForClient",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startOn",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spotsAvailable",
  "storageKey": null
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v24 = [
  (v23/*: any*/),
  (v9/*: any*/)
],
v25 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "EventTagConnection",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventTagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventTag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v24/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tags(first:1000)"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": (v22/*: any*/),
  "concreteType": "EventSessionConnection",
  "kind": "LinkedField",
  "name": "eventSessions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSessionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSession",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseConnection",
              "kind": "LinkedField",
              "name": "courses",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Course",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v9/*: any*/),
                        (v23/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CourseBucket",
                          "kind": "LinkedField",
                          "name": "courseBucket",
                          "plural": false,
                          "selections": (v24/*: any*/),
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "event",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EventSeries",
                  "kind": "LinkedField",
                  "name": "eventSeries",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Facility",
                      "kind": "LinkedField",
                      "name": "facility",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FacilityCopyOverrides",
                          "kind": "LinkedField",
                          "name": "copyOverrides",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "NounOverride",
                              "kind": "LinkedField",
                              "name": "course",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "singular",
                                  "storageKey": null
                                },
                                (v26/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        (v9/*: any*/)
                      ],
                      "storageKey": null
                    },
                    (v9/*: any*/)
                  ],
                  "storageKey": null
                },
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "eventSessions(first:1000)"
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opensAt",
  "storageKey": null
},
v29 = [
  (v26/*: any*/)
],
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "EventSeries",
  "kind": "LinkedField",
  "name": "eventSeries",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Facility",
      "kind": "LinkedField",
      "name": "facility",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacilityCopyOverrides",
          "kind": "LinkedField",
          "name": "copyOverrides",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "NounOverride",
              "kind": "LinkedField",
              "name": "course",
              "plural": false,
              "selections": (v29/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Department",
          "kind": "LinkedField",
          "name": "department",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "type",
              "storageKey": null
            },
            (v23/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": (v16/*: any*/),
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v10/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endOn",
              "storageKey": null
            },
            (v21/*: any*/),
            (v25/*: any*/),
            (v27/*: any*/),
            {
              "alias": null,
              "args": (v17/*: any*/),
              "concreteType": "EventSignUpWindow",
              "kind": "LinkedField",
              "name": "clientEligibleSignUpWindows",
              "plural": true,
              "selections": [
                (v9/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "closesAt",
                  "storageKey": null
                },
                (v28/*: any*/)
              ],
              "storageKey": null
            },
            (v30/*: any*/)
          ],
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "ClubCopyOverrides",
  "kind": "LinkedField",
  "name": "copyOverrides",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NounOverride",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": (v29/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v35 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  },
  (v15/*: any*/)
],
v36 = {
  "alias": "upcomingEvents",
  "args": (v35/*: any*/),
  "concreteType": "EventConnection",
  "kind": "LinkedField",
  "name": "events",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v20/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v21/*: any*/),
            (v25/*: any*/),
            (v27/*: any*/),
            {
              "alias": null,
              "args": (v17/*: any*/),
              "concreteType": "EventSignUpWindow",
              "kind": "LinkedField",
              "name": "clientEligibleSignUpWindows",
              "plural": true,
              "selections": [
                (v28/*: any*/),
                (v9/*: any*/)
              ],
              "storageKey": null
            },
            (v30/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        },
        (v31/*: any*/)
      ],
      "storageKey": null
    },
    (v32/*: any*/)
  ],
  "storageKey": null
},
v37 = [
  "dateGte",
  "dateLte",
  "search",
  "tagIds"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewPatronEventsListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeaturedEventsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UpcomingEventsClub_club"
              }
            ],
            "type": "Club",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FeaturedEventsDepartmentFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UpcomingEventsDepartment_department"
              }
            ],
            "type": "Department",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "NewPatronEventsListQuery",
    "selections": [
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v33/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "dateGte",
                  "isFeatured",
                  "dateLte",
                  "tagIds"
                ],
                "handle": "connection",
                "key": "FeaturedEventsFragment_events",
                "kind": "LinkedHandle",
                "name": "events"
              },
              (v34/*: any*/),
              (v36/*: any*/),
              {
                "alias": "upcomingEvents",
                "args": (v35/*: any*/),
                "filters": (v37/*: any*/),
                "handle": "connection",
                "key": "UpcomingEventsClub_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "events"
              }
            ],
            "type": "Club",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v33/*: any*/),
              {
                "alias": null,
                "args": (v16/*: any*/),
                "filters": [
                  "dateGte",
                  "dateLte",
                  "isFeatured",
                  "tagIds"
                ],
                "handle": "connection",
                "key": "FeaturedEventsFragment_events",
                "kind": "LinkedHandle",
                "name": "events"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Club",
                "kind": "LinkedField",
                "name": "club",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v36/*: any*/),
              {
                "alias": "upcomingEvents",
                "args": (v35/*: any*/),
                "filters": (v37/*: any*/),
                "handle": "connection",
                "key": "UpcomingEventsDepartment_upcomingEvents",
                "kind": "LinkedHandle",
                "name": "events"
              }
            ],
            "type": "Department",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "00f6a0fcc2235fc6f5af1fdc12c4525e",
    "id": null,
    "metadata": {},
    "name": "NewPatronEventsListQuery",
    "operationKind": "query",
    "text": "query NewPatronEventsListQuery(\n  $id: ID!\n  $count: Int!\n  $cursor: String\n  $memberId: ID\n  $startDate: Date\n  $endDate: Date\n  $eventTags: [ID]\n  $search: String\n) {\n  node(id: $id) {\n    id\n    __typename\n    ... on Club {\n      ...FeaturedEventsFragment\n      ...UpcomingEventsClub_club\n    }\n    ... on Department {\n      ...FeaturedEventsDepartmentFragment\n      ...UpcomingEventsDepartment_department\n    }\n  }\n}\n\nfragment EventCardWrapper on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  startOn\n  endOn\n  spotsAvailable\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        ...useEventLocationLabel_Event\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    id\n    closesAt\n    opensAt\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment FeaturedEventsDepartmentFragment on Department {\n  events(first: $count, after: $cursor, dateGte: $startDate, dateLte: $endDate, isFeatured: true, tagIds: $eventTags) {\n    count\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...FeaturedEventsScrollerEventConnection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment FeaturedEventsFragment on Club {\n  events(first: $count, after: $cursor, dateGte: $startDate, isFeatured: true, dateLte: $endDate, tagIds: $eventTags) {\n    count\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...FeaturedEventsScrollerEventConnection\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment FeaturedEventsScrollerEventConnection on EventConnection {\n  edges {\n    node {\n      id\n      ...EventCardWrapper\n    }\n  }\n}\n\nfragment NewPatronEventCardWrapper on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  signUpStatusForClient(clientId: $memberId)\n  startOn\n  spotsAvailable\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        ...useEventLocationLabel_Event\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    opensAt\n    id\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment UpcomingEventsClub_club on Club {\n  copyOverrides {\n    event {\n      plural\n    }\n  }\n  upcomingEvents: events(first: $count, after: $cursor, dateGte: $startDate, dateLte: $endDate, search: $search, tagIds: $eventTags) {\n    edges {\n      node {\n        id\n        startOn\n        ...NewPatronEventCardWrapper\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment UpcomingEventsDepartment_department on Department {\n  club {\n    copyOverrides {\n      event {\n        plural\n      }\n    }\n    id\n  }\n  upcomingEvents: events(first: $count, after: $cursor, dateGte: $startDate, dateLte: $endDate, search: $search, tagIds: $eventTags) {\n    edges {\n      node {\n        id\n        startOn\n        ...NewPatronEventCardWrapper\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b36a5c935e4d50a3fd6f0889569e8dc6";

export default node;
